import { AccordionSection } from 'components/Accordion';
import { Text } from 'components/Text';
import { getLocaleLanguage, getTrans } from 'modules/i18n';
import {
  androidBrowserImages,
  androidBrowserVideoUrl,
  androidDeviceImages,
  androidSystemVideoUrl,
  getAndroidBrowserInstructions,
  getAndroidDeviceInstructions
} from '../constants';
import { Instructions } from './Instructions';
import { SizedBox } from './SizedBox';
import { Video } from './Video';

export const AndroidInstructions = () => {
  const localeLanguage = getLocaleLanguage();

  const androidDeviceInstructions = getAndroidDeviceInstructions();
  const androidBrowserInstructions = getAndroidBrowserInstructions();

  return (
    <>
      <AccordionSection
        title={getTrans('geolocationSettingsPage.instructions.device.title')}
      >
        <Video videoUrl={androidSystemVideoUrl} />
        <Instructions
          instructions={androidDeviceInstructions}
          images={androidDeviceImages[localeLanguage]}
        />
        <SizedBox>
          <Text variant="body2" mt={1}>
            <b>
              {getTrans('geolocationSettingsPage.instructions.final.part1')}
            </b>
            &nbsp;
            {getTrans('geolocationSettingsPage.instructions.final.part2')}
          </Text>
        </SizedBox>
      </AccordionSection>
      <AccordionSection
        title={getTrans('geolocationSettingsPage.instructions.browser.title')}
      >
        <Video videoUrl={androidBrowserVideoUrl} />
        <Instructions
          instructions={androidBrowserInstructions}
          images={androidBrowserImages[localeLanguage]}
        />
        <SizedBox>
          <Text variant="body2" mt={1}>
            <b>
              {getTrans(
                'geolocationSettingsPage.instructions.browser.final.part1'
              )}
            </b>
            &nbsp;
            {getTrans(
              'geolocationSettingsPage.instructions.browser.final.part2'
            )}
          </Text>
        </SizedBox>
      </AccordionSection>
    </>
  );
};
